import BottyAI from "src/modules/data-protection/assets/images/ai-botty/loading.png";

const LoadingStep = ({ t }) => (
  <div className="text-center">
    <h5 className="my-5">
      {t("Hi, I'm Botty. The AI Assistant from DISS-CO.")}
    </h5>
    <img className="mb-3" src={BottyAI} width="50%" height="50%" alt="Botty" />
    <h6 className="my-5">
      {t(
        "I'm analyzing the software information to prefill the form. This may take a few moments..."
      )}
    </h6>
  </div>
);

export default LoadingStep;
